import {Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {KtTripService} from '../service/kt-trip.service';
import {IKtTripListItem} from '../interfaces/kt-trip.interface';

@Component({
  selector: 'app-kt-trip-detail',
  templateUrl: './kt-trip-detail.component.html',
  standalone: false,
})
export class KtTripDetailComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly tripService = inject(KtTripService);

  protected readonly trip = signal<IKtTripListItem | null>(null);
  protected readonly tripId = signal<number | null>(null);

  public ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.tripId.set(id);
    this.tripService.getTripById(id).subscribe(t => this.trip.set(t));
  }
}
